import React from 'react';

const testIds = {
    FULL_SCREEN_ICON: 'FULL_SCREEN_ICON'
};

const FullScreenIcon = (props: any) => (
    <svg
        data-test-id={testIds.FULL_SCREEN_ICON}
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6 10H4V4H10V6H6V10ZM18 10H20V4H14V6H18V10ZM14 20H20V14H18V18H14V20ZM4 20H10V18H6V14H4V20Z"
            fill="#F9FAFA"
        />
    </svg>
);

export {FullScreenIcon};
